import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["clsPrefix", "value", "onChange"];

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import RcTimePicker from './rc/index';
import PropTypes from 'prop-types';
import moment from 'moment';
import { WebUI } from "../../wui-core/src/index.js";
var propTypes = {};
var defaultProps = {
  allowClear: true,
  //默认允许清除
  focusOnOpen: true,
  clearIcon: /*#__PURE__*/React.createElement("i", {
    className: "uf uf-close-c"
  }),
  inputIcon: /*#__PURE__*/React.createElement("i", {
    className: "uf uf-time-c-o"
  }),
  onKeyDown: function onKeyDown() {}
};
var TimePicker = (_dec = WebUI({
  name: "time-picker",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(TimePicker, _Component);

  var _super = _createSuper(TimePicker);

  function TimePicker(props) {
    var _this;

    _classCallCheck(this, TimePicker);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "initValue", function () {});

    _this.state = {
      value: props.value
    };
    return _this;
  }

  _createClass(TimePicker, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      //判断初始值是否合法，不合法则格式化
      var value = this.props.value;

      if (value) {
        if (typeof value == 'string') {
          value = moment("".concat(moment().format('YYYY-MM-DD'), " ").concat(value));
          this.setState({
            value: value
          }); // this.props.onChange&&this.props.onChange(value)
        } else if (value.format) {
          if (!value.isValid()) {
            value = moment("".concat(moment().format('YYYY-MM-DD'), " ").concat(value._i));
            this.setState({
              value: value
            }); // this.props.onChange&&this.props.onChange(value)
          }
        }
      } else {
        value = null;
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('value' in nextProps) {
        var value = nextProps.value;

        if (value) {
          if (typeof value == 'string') {
            value = moment("".concat(moment().format('YYYY-MM-DD'), " ").concat(value));
          } else if (value.format) {
            if (!value.isValid()) {
              value = moment("".concat(moment().format('YYYY-MM-DD'), " ").concat(value._i));
            }
          }
        } else {
          value = null;
        }

        this.setState({
          value: value
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          clsPrefix = _this$props.clsPrefix,
          value = _this$props.value,
          _onChange = _this$props.onChange,
          other = _objectWithoutProperties(_this$props, _excluded);

      return /*#__PURE__*/React.createElement(RcTimePicker, _extends({
        prefixCls: clsPrefix,
        value: this.state.value
      }, other, {
        onChange: function onChange(value) {
          _this2.setState({
            value: value
          });

          _onChange(value);
        }
      }));
    }
  }]);

  return TimePicker;
}(Component)) || _class);
;
TimePicker.propTypes = propTypes;
export default TimePicker;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-timepicker/src/TimePicker.js